import { createContext, useContext, useEffect, useMemo, useState } from "react";

const QuoteContext = createContext(null);
const KEY = "sr_quote_items";

export function QuoteProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const value = useMemo(() => ({
    items, open, setOpen,
    count: items.reduce((s, i) => s + i.quantity, 0),
    add: (p, qty = 1) => setItems((prev) => {
      const ex = prev.find((i) => i.product_id === p.product_id);
      if (ex) return prev.map((i) => (i.product_id === p.product_id ? { ...i, quantity: i.quantity + qty } : i));
      return [...prev, { product_id: p.product_id, name: p.name, size: p.size, brand_name: p.brand_name, case_pack: p.case_pack, image: p.image, quantity: qty }];
    }),
    setQty: (id, q) => setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, q) } : i))),
    remove: (id) => setItems((prev) => prev.filter((i) => i.product_id !== id)),
    clear: () => setItems([]),
  }), [items, open]);

  return <QuoteContext.Provider value={value}>{children}</QuoteContext.Provider>;
}

export const useQuote = () => useContext(QuoteContext);
